import React from 'react';
import nftLanding from '../../Images/nftlanding.png'
import logo from '../../Images/logo.png'
import './Landing.scss'

function Landing() {
  return (
    <div id='landing'>
      <div className='row'>
        <div className='col-md-4'>
          <img className='logoText' src={logo} alt="nft" />
          <p className='subTitle'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ea, vitae.</p>
          <p className='subTitle2'>DOLOR SIT AMIT<span className='slashPadding'>/</span>DOLOR SIT AMIT</p>
        </div>
        
        <div className='col-md-8'>
          <img className='nftLanding' src={nftLanding} alt="nft" />
        </div>
      </div>
    </div>
  )
}

export default Landing;
